import * as React from "react";
import { StyleSheet, View, Text, TouchableOpacity, Dimensions } from "react-native";
import MainMenuButton from "../MainMenuButton";
import BlueBarCodeButton from "../BlueBarCodeButton";
import BackButton from "../BackButton";
import BackButtonTop from "../BackButtonTop";
import BackButtonTopWhite from "../BackButtonTopWhite";
import LaunchFilterButton from "../LaunchFilterButton";
import ToggleInstore from "../ToggleInstore";
import ToggleOnline from "../ToggleOnline";
import { EvilIcons, MaterialIcons } from "@expo/vector-icons";
import GlobalStyles from "../../components/GlobalStyles";

export default function StatusBar(props) {
  return <View>{switchBar(props.data, props.callback, props.locationSearching, props.locationSpinner)}</View>;
}
function switchBar(key, callbackFunc = null, locationSearching = false, locationSpinner = false) {
  switch (key) {
    case "B":
      return (
        <View style={styles.statusBox}>
          <View style={styles.leftBox}>
            <BackButtonTop />
          </View>
          <View style={styles.rightBox}></View>
        </View>
      );
      break;
    case "BM":
      return (
        <View style={styles.statusBox}>
          <View style={styles.leftBox}>
            <BackButton />
          </View>
          <View style={styles.rightBox}>
            <MainMenuButton />
          </View>
        </View>
      );
      break;
    case "MM":
      return (
        <View style={styles.statusBox}>
          <View style={styles.leftBox}>
            <BackButtonTop />
          </View>
          <View style={styles.rightBox}>
            <MainMenuButton />
          </View>
        </View>
      );
      break;
    case "C":
      return (
        <View style={styles.statusBox}>
          <View style={styles.leftBox}>
            <BackButton />
          </View>
          <View style={styles.rightBox}>
            <BlueBarCodeButton />
          </View>
        </View>
      );
      break;
    case "F":
      return (
        <View style={styles.statusBox}>
          <View style={styles.leftBox}>
            <BackButton />
          </View>
          <View style={styles.rightBox}>
            <LaunchFilterButton />
          </View>
        </View>
      );
      break;
    case "FW":
      return (
        <View style={styles.rightBox}>
          <LaunchFilterButton />
        </View>
      );
      break;
    case "B_T":
      return (
        <View style={styles.statusBoxTrans}>
          <View style={styles.leftBox}>
            <BackButtonTopWhite />
          </View>
          <View style={styles.rightBox}>

          </View>
        </View>
      );
      break;
    case "B_OL":
      return (
        <View style={styles.statusBoxTrans}>
          <View style={styles.leftBox}>
            <BackButtonTopWhite />
          </View>
          <View style={styles.rightBox}>
            <ToggleOnline />
          </View>
        </View>
      );
      break;
    case "B_IS":
      return (
        <View style={styles.statusBoxTrans}>
          <View style={styles.leftBox}>
            <BackButtonTopWhite />
          </View>
          <View style={styles.midBox}>
            <ToggleInstore />
          </View>
          <View style={styles.rightBox}>
            <TouchableOpacity
              activeOpacity={0.2}
              underlayColor="rgba(255,199,44,1)"
              onPress={() => callbackFunc()}
            >
              <View style={styles.locationContainer}>
                {locationSpinner ?
                  <>
                    <EvilIcons name="spinner" size={25} color="#FFFFFF" />
                    <Text style={[GlobalStyles.subheaderStyleWeb, { color: "#FFFFFF", marginLeft: 5, paddingTop: 3, }]}>{'NEAR ME'}</Text>
                  </>
                  :
                  locationSearching ?
                    <>
                      <MaterialIcons name="location-on" size={15} color="#FFFFFF" />
                      <Text style={[GlobalStyles.subheaderStyleWeb, { color: "#FFFFFF", marginLeft: 5, paddingTop: 3, }]}>NEAR ME</Text>
                    </>
                    :
                    <>
                      <MaterialIcons name="location-off" size={15} color="#000000" />
                      <Text style={[GlobalStyles.subheaderStyleWeb, { color: "#000000", marginLeft: 5, paddingTop: 3, }]}>NEAR ME</Text>
                    </>
                }
              </View>
            </TouchableOpacity>
          </View>
        </View>
      );
      break;
    case "EMPTY":
      return (
        <View style={styles.statusBox}>
          <View style={styles.leftBox}>
            <View style={styles.spacerContainer}></View>
          </View>
          <View style={styles.rightBox}></View>
        </View>
      );
      break;
    default:
      break;
  }
}
const styles = StyleSheet.create({
  statusBox: {
    //flex: 1,
    flexDirection: "row",
    backgroundColor: "#FFFFFF",
    height: 70,
    paddingTop: 40,
  },
  statusBoxTrans: {
    //flex: 1,
    flexDirection: "row",
    //backgroundColor: "#FFFFFF",
    height: 70,
    paddingTop: 40,
  },

  leftBox: {
    flex: 1,
    alignItems: "flex-start",
  },
  rightBox: {
    flex: 1,
    alignItems: "flex-end",
  },
  midBox: {
    flex: 1,
    alignItems: "center",
  },
  spacerContainer: {
    paddingLeft: 15,
    paddingRight: 30,
  },
  locationContainer: {
    flexDirection: "row",
    paddingTop: 9,
    //marginLeft: 20,
    marginRight: 10,
    alignItems: "flex-start",
  },
});
